import React, { useEffect, useState } from 'react'
import { Button } from 'reactstrap'
import {
	getAwardsListLevelCount,
	getAwardsListRankingCount,
	getAwardsListGradeLevelCount,
	getOverviewTexts,
	saveOverviewTexts
} from '../../lib/studentawardsreport'
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents'

// Color mapping styles
const colorStyles = {
	blue: { backgroundColor: '#b3e5fc' },
	green: { backgroundColor: '#c8e6c9' },
	yellow: { backgroundColor: '#fff9c4' },
	orange: { backgroundColor: '#ffe0b2' },
	lightRed: { backgroundColor: '#ffcdd2' },
	red: { backgroundColor: '#ef9a9a' },
	default: { backgroundColor: '#f1f1f1' }
}

const RecognitionTable = ({ recognition, overview, onOverviewChange }) => {
	const total = recognition.reduce((sum, r) => sum + (r.Count || 0), 0)
	const rowCount = recognition.length

	return (
		<>
			<div
				style={{
					background: '#666',
					color: '#fff',
					fontWeight: 'bold',
					fontSize: '1.1rem',
					padding: '8px 12px',
					borderRadius: '2px 2px 0 0',
					letterSpacing: '1px'
				}}
			>
				RECOGNITION
			</div>
			<table className="table table-bordered text-center mb-0">
				<colgroup>
					<col style={{ width: '30%' }} />
					<col style={{ width: '20%' }} />
					<col style={{ width: '50%' }} />
				</colgroup>
				<thead>
					<tr>
						<th style={{ background: '#ddd', color: '#222', fontWeight: 'bold' }}>Level</th>
						<th style={{ background: '#ddd', color: '#222', fontWeight: 'bold' }}>Count</th>
						<th style={{ background: '#ddd', color: '#222', fontWeight: 'bold' }}>Overview</th>
					</tr>
				</thead>
				<tbody>
					{recognition.map((r, index) => (
						<tr key={`recognition-${r.Level}`}>
							<td>{r.Level}</td>
							<td style={{ ...r.Color, color: '#000' }}>{r.Count}</td>
							{index === 0 && (
								<td rowSpan={rowCount + 1} style={{ verticalAlign: 'middle', padding: '8px' }}>
									<textarea
										rows={rowCount * 2}
										className="form-control"
										value={overview['recognition'] || ''}
										onChange={(e) => onOverviewChange('recognition', e.target.value)}
										style={{ minHeight: '100px' }}
									/>
								</td>
							)}
						</tr>
					))}
					<tr style={{ background: '#bcb9b9', fontWeight: 'bold' }}>
						<td>Total</td>
						<td>{total}</td>
					</tr>
				</tbody>
			</table>
		</>
	)
}

const RankingTable = ({ ranking, overview, onOverviewChange }) => {
	const total = ranking.reduce((sum, r) => sum + (r.Count || 0), 0)
	const rowCount = ranking.length

	return (
		<>
			<div
				style={{
					background: '#666',
					color: '#fff',
					fontWeight: 'bold',
					fontSize: '1.1rem',
					padding: '8px 12px',
					borderRadius: '2px 2px 0 0',
					letterSpacing: '1px'
				}}
			>
				RANKING
			</div>
			<table className="table table-bordered text-center mb-0">
				<colgroup>
					<col style={{ width: '30%' }} />
					<col style={{ width: '20%' }} />
					<col style={{ width: '50%' }} />
				</colgroup>
				<thead>
					<tr>
						<th style={{ background: '#ddd', color: '#222', fontWeight: 'bold' }}>Ranking</th>
						<th style={{ background: '#ddd', color: '#222', fontWeight: 'bold' }}>Count</th>
						<th style={{ background: '#ddd', color: '#222', fontWeight: 'bold' }}>Overview</th>
					</tr>
				</thead>
				<tbody>
					{ranking.map((r, index) => (
						<tr key={`ranking-${r.Ranking}`}>
							<td>{r.Ranking}</td>
							<td style={{ ...r.Color, color: '#000' }}>{r.Count}</td>
							{index === 0 && (
								<td rowSpan={rowCount + 1} style={{ verticalAlign: 'middle', padding: '8px' }}>
									<textarea
										rows={rowCount * 2}
										className="form-control"
										value={overview['ranking'] || ''}
										onChange={(e) => onOverviewChange('ranking', e.target.value)}
										style={{ minHeight: '100px' }}
									/>
								</td>
							)}
						</tr>
					))}
					<tr style={{ background: '#bcb9b9', fontWeight: 'bold' }}>
						<td>Total</td>
						<td>{total}</td>
					</tr>
				</tbody>
			</table>
		</>
	)
}

const GradeLevelTable = ({ gradeLevel, overview, onOverviewChange }) => {
	const total = gradeLevel.reduce((sum, g) => sum + (g.Count || 0), 0)
	const rowCount = gradeLevel.length

	return (
		<>
			<div
				style={{
					background: '#666',
					color: '#fff',
					fontWeight: 'bold',
					fontSize: '1.1rem',
					padding: '8px 12px',
					borderRadius: '2px 2px 0 0',
					letterSpacing: '1px'
				}}
			>
				GRADE LEVEL
			</div>
			<table className="table table-bordered text-center mb-0">
				<colgroup>
					<col style={{ width: '30%' }} />
					<col style={{ width: '20%' }} />
					<col style={{ width: '50%' }} />
				</colgroup>
				<thead>
					<tr>
						<th style={{ background: '#ddd', color: '#222', fontWeight: 'bold' }}>Year</th>
						<th style={{ background: '#ddd', color: '#222', fontWeight: 'bold' }}>Count</th>
						<th style={{ background: '#ddd', color: '#222', fontWeight: 'bold' }}>Overview</th>
					</tr>
				</thead>
				<tbody>
					{gradeLevel.map((g, index) => (
						<tr key={`gradeLevel-${g.Year}`}>
							<td>Grade-{g.Year}</td>
							<td style={{ ...g.Color, color: '#000' }}>{g.Count}</td>
							{index === 0 && (
								<td rowSpan={rowCount + 1} style={{ verticalAlign: 'middle', padding: '8px' }}>
									<textarea
										rows={rowCount * 2}
										className="form-control"
										value={overview['gradeLevel'] || ''}
										onChange={(e) => onOverviewChange('gradeLevel', e.target.value)}
										style={{ minHeight: '100px' }}
									/>
								</td>
							)}
						</tr>
					))}
					<tr style={{ background: '#bcb9b9', fontWeight: 'bold' }}>
						<td>HS Total</td>
						<td>{total}</td>
					</tr>
				</tbody>
			</table>
		</>
	)
}

const StudentAwardsReportList = ({ studentId, isStudentView = false }) => {
	const [recognition, setRecognition] = useState([])
	const [ranking, setRanking] = useState([])
	const [gradeLevel, setGradeLevel] = useState([])
	const [overview, setOverview] = useState({})
	const [loading, setLoading] = useState(true)
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)
	const [updating, setUpdating] = useState(false)

	const loadData = async () => {
		setLoading(true)
		try {
			// Load all data in parallel
			const [recognitionRes, rankingRes, gradeLevelRes, overviewRes] = await Promise.all([
				getAwardsListLevelCount(studentId),
				getAwardsListRankingCount(studentId),
				getAwardsListGradeLevelCount(studentId),
				getOverviewTexts(studentId)
			])

			// Map recognition data with colors
			const recognitionTypes = {
				International: colorStyles.blue,
				National: colorStyles.green,
				Regional: colorStyles.yellow,
				State: colorStyles.orange,
				City: colorStyles.lightRed,
				School: colorStyles.red
			}

			const recognitionMap = recognitionRes.reduce((acc, item) => {
				acc[item.Level] = {
					Level: item.Level,
					Count: item.Count,
					Color: recognitionTypes[item.Level] || colorStyles.default
				}
				return acc
			}, {})
			setRecognition(Object.values(recognitionMap))

			// Map ranking data with colors
			const rankingTypes = {
				'1 or 2': colorStyles.blue,
				'3 or 4': colorStyles.green,
				'5 or 6': colorStyles.yellow,
				'7 or More': colorStyles.orange,
				Certificate: colorStyles.lightRed,
				Participation: colorStyles.red
			}

			const rankingMap = rankingRes.reduce((acc, item) => {
				acc[item.Ranking] = {
					Ranking: item.Ranking,
					Count: item.Count,
					Color: rankingTypes[item.Ranking] || colorStyles.default
				}
				return acc
			}, {})
			setRanking(Object.values(rankingMap))

			// Map grade level data with colors
			const gradeLevelTypes = {
				7: colorStyles.blue,
				8: colorStyles.green,
				9: colorStyles.yellow,
				10: colorStyles.orange,
				11: colorStyles.lightRed,
				12: colorStyles.red
			}

			const gradeLevelMap = gradeLevelRes.reduce((acc, item) => {
				acc[item.Year] = {
					Year: item.Year,
					Count: item.Count,
					Color: gradeLevelTypes[item.Year] || colorStyles.default
				}
				return acc
			}, {})
			setGradeLevel(Object.values(gradeLevelMap))

			// Map overview data
			const overviewMap = {}
			overviewRes.forEach((item) => {
				overviewMap[item.type] = item.desc
			})
			setOverview(overviewMap)
		} catch (error) {
			console.error('Error loading award reports:', error)
		} finally {
			setLoading(false)
		}
	}

	const handleOverviewChange = (key, value) => {
		setOverview((prev) => ({ ...prev, [key]: value }))
	}

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	const handleUpdate = async () => {
		setUpdating(true)
		try {
			await saveOverviewTexts(studentId, overview)
			showToastMessage('Overview texts updated successfully!')
			await loadData()
		} catch (error) {
			console.error('Error updating overview:', error)
		} finally {
			setUpdating(false)
		}
	}

	useEffect(() => {
		if (studentId) {
			loadData()
		}
	}, [studentId])

	if (loading) {
		return (
			<div className="card p-4 text-center">
				<i className="fa fa-spinner fa-spin fa-3x"></i>
				<p className="mt-3">Loading award reports...</p>
			</div>
		)
	}

	return (
		<div className="card p-4">
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
			<h4 className="mb-3">Awards Reports</h4>

			<div className="mb-4">
				<RecognitionTable recognition={recognition} overview={overview} onOverviewChange={handleOverviewChange} />
			</div>

			<div className="mb-4">
				<RankingTable ranking={ranking} overview={overview} onOverviewChange={handleOverviewChange} />
			</div>

			<div className="mb-4">
				<GradeLevelTable gradeLevel={gradeLevel} overview={overview} onOverviewChange={handleOverviewChange} />
			</div>

			<div className="text-end">
				<Button color="primary" onClick={handleUpdate} disabled={updating}>
					<i className="fa fa-save me-2"></i>
					{updating ? 'Updating...' : 'Update'}
				</Button>
			</div>
		</div>
	)
}

export { StudentAwardsReportList }
